import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

@LazyClientConfig({ key: 'globalSearch', product: ClientConfigProductName.CASINO })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: globalSearchConfigfactory,
})
export class GlobalSearchClientConfig extends LazyClientConfigBase {
    contextPath: string | undefined;
    searchLanguage: string | undefined;
    transportToken: string | undefined;
    assetPaths: IAssetPaths | undefined;
    stickyicondragabble: boolean | undefined;
}
export interface IAssetPaths {
    scripts: string[];
    styles: string[];
}

export function globalSearchConfigfactory(clientConfigService: LazyClientConfigService) {
    return clientConfigService.get(GlobalSearchClientConfig);
}
